import React, { useState } from 'react';
import { CalendarToday } from '@mui/icons-material';
import SourceDestination from '../components/booking/common/SourceDestination'
import { dateFormat } from '../components/booking/components/common/dateUtils'
import CardImageRight from '../components/booking/common/CardImageRight'
import PeopleIcon from '@mui/icons-material/People';
import LuggageIcon from '@mui/icons-material/Luggage';
import EstimatedFare from '../components/booking/common/EstimatedFare'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { emptyFormValues } from '../components/booking/components/common/bookingUtils'
import Alert from '@mui/material/Alert';
import { createOrAddUserDetails } from "../components/services/createOrAddUserDetailsService"
import { Booking, } from '../components/models/booking'
import { AppContext } from '../components/services/AppContext'
import BookingDetails from '../components/booking/common/BookingDetails'
import { createOrGetUser } from "../components/services/createOrGetUserService"
import { createNewBookingService } from "../components/services/createNewBookingService"
import ProgressMessage from "../components/booking/common/ProgressMessage"
import '../styles/commonStyle.css';
import { RequestBookingService } from "../components/services/RequestBookingService"
import { CarModel } from '../components/models/CarModel'
import { deleteEnquiryById } from "../components/services/userEnquiryLogService"
import { useNavigate } from "react-router-dom";

interface Form3Props {
  formValues: any;
  handleBack: () => void;
}

const NewBookingForm3: React.FC<Form3Props> = ({ formValues, handleBack, }) => {
  const navigate = useNavigate();
  const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [progressMessage, setProgressMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [createdBooking, setCreatedBooking] = useState<Booking>()
  const [selectedCar, setSelectedCar] = useState<CarModel>(AppContext.selectedCar)
  const bookingDateTime = `${formValues.bookingDate}T${formValues.bookingTime?.trimLeft()}`;

  const convertDateTimetoUTC = (dateTime: string) => {
    const localDate = new Date(dateTime);
    const userUtcOffset = localDate.getTimezoneOffset();

    localDate.setMinutes(localDate.getMinutes() - userUtcOffset - 330);

    return localDate.toISOString();
  };

  const handleSubmit = async () => {
    // console.log("Submit button clicked!");
    AppContext.grpLastMinuteBooking = false

    setLoading(true);
    setProgressMessage("Please Wait....");
    const user = await createOrGetUser(formValues.name, AppContext.phone)
    if (user)
      await createOrAddUserDetails(user)

    const bookingData = {
      name: formValues.name,
      bookingDate: convertDateTimetoUTC(bookingDateTime),
      carId: AppContext.emptyObjectId,
      driverId: AppContext.emptyObjectId
    };

    let data: Booking | null = null;

    setTimeout(async () => {
      if (user)
        data = await createNewBookingService(user, bookingData);
      // console.log("data  " + JSON.stringify(data))
      if (data) {
        // setMessage("Your booking request has been accepted. We will check the availability and send a confirmation to your WhatsApp number shortly.");
        // setCreatedBooking(data)
        // setIsSuccess(true);
       await deleteEnquiryById(AppContext.selectedEnquiry._id)
        formValues = emptyFormValues()
        RequestBookingService.setToInitialState()
        AppContext.travelDate = ""
        AppContext.travelTime = ""
        AppContext.selectedSourceTerminal = ''
        AppContext.selectedDestinationTerminal = ''
        AppContext.selectedRoute = ''
        AppContext.isLastMinuteFareEligible = false
        setLoading(false)
        navigate(`/booking-request/${data.bookingId}`);
      } else {
        setMessage("Booking could not be created. Please try again later.");
        formValues = emptyFormValues()
        setIsSuccess(false);
        setLoading(false)
      }

    }, 1000);
  };

  return (
    <div>
      <div className="container">
        <div className="row gx-1 gx-sm-2 gx-md-3 gy-1">
          {loading && <ProgressMessage progressMessage={progressMessage} />}

          {message ? (
            <div className="col-12 text-center mb-2">
              <h5 className="text-success">Booking Confirmation</h5>
              <hr className="mb-2" />
              <Alert
                severity={isSuccess ? "success" : "error"}
                icon={isSuccess ? <CheckCircleIcon fontSize="large" /> : <ErrorIcon fontSize="large" />}
                sx={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  backgroundColor: isSuccess ? '#e8f5e9' : '#f8d7da',
                  color: isSuccess ? '#388e3c' : '#721c24',
                  borderRadius: 2,
                  fontSize: 18,
                  width: "100%",
                  marginTop: 3,
                }}
              >
                {message}
              </Alert>
              <BookingDetails booking={createdBooking} />
            </div>
          ) : (
              <>
                <div className="col-12 text-center mb-2">
                  <h5 className="text-success">Your Booking Request - Review</h5>
                  <hr className="mb-2" />
                </div>

                <div className="col-12 col-sm-6 col-md-6">
                  <div className="d-flex align-items-center mb-2">
                    <CalendarToday style={{ color: '#4caf50' }} className="me-2" />
                    <span>Booking: {dateFormat(bookingDateTime)}</span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <PeopleIcon style={{ color: '#4caf50' }} className="me-2" />
                    <span>Number of Passengers: {RequestBookingService.getRequestBooking().booking.numberOfPassengers}</span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <LuggageIcon style={{ color: '#4caf50' }} className="me-2" />
                    <span>Number of Big Bags: {RequestBookingService.getRequestBooking().booking.numberOfBigBags}</span>
                  </div>
                  <hr className="mb-1" />
                </div>

                <div className="col-12 col-sm-6 col-md-6">
                  <SourceDestination
                    source={RequestBookingService.getSourceFormattedAddress()}
                    destination={RequestBookingService.getDestinationFormattedAddress()}
                  />
                  <hr className="mt-1" />
                </div>

                <div className="col-12">
                  <CardImageRight
                    header={selectedCar?.carModel}
                    text1={selectedCar?.carType}
                    text2={'Quiet & Comfortable'}
                    text3={''}
                    imageSource={selectedCar?.carModel}
                  />
                </div>

                <EstimatedFare booking={RequestBookingService.getRequestBooking().booking} />

                <div className="col-6">
                  <button
                    type="button"
                    className="btn w-100 back-button"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                </div>

                <div className="col-6">
                  <button
                    type="button"
                    className="btn w-100 primary-button"
                    onClick={handleSubmit}
                  >
                    Submit
                 </button>
                </div>

              </>
            )}
        </div>
      </div>

      <br />
    </div>

  );
};

export default NewBookingForm3;